/*
 * Evergreen homepage: keeps every "Get your Tin Can" link pointed at the
 * colour picked in Behold (hev:colorchange), so the PDP opens on that colour.
 */
(function () {
  document.addEventListener('hev:colorchange', function (event) {
    var id = event.detail && event.detail.variantId;
    document.querySelectorAll('[data-hev-product-link]').forEach(function (link) {
      var base = link.getAttribute('data-base-url');
      if (!base) {
        base = link.getAttribute('href').split('?')[0];
        link.setAttribute('data-base-url', base);
      }
      link.href = id ? base + '?variant=' + encodeURIComponent(id) : base;
    });
  });
})();
